import React from 'react';
import { useNavigate } from 'react-router-dom';

// First 5 B2C categories (from data.js)
const b2cCategories = [
  { id: 1, name: 'Dairy, Bread & Eggs' },
  { id: 2, name: 'Snack & Munchies' },
  { id: 3, name: 'Bakery & Biscuits' },
  { id: 4, name: 'Instant Food' },
  { id: 5, name: 'Tea, Coffee & Drinks' },
];

// First 5 B2B categories (from b2b_categories table)
const b2bCategories = [
  { id: 1, name: 'Vegetables & Fruits' },
  { id: 2, name: 'Dairy Bulk' },
  { id: 3, name: 'Grains & Pulses' },
  { id: 4, name: 'Restaurant Supplies' },
];

const footerLinks = {
  'Company': [
    { label: 'About Us', route: '/about' },
    { label: 'Contact', route: '/contact' },
  ],
  'For Customers': [
    { label: 'My Orders', route: '/my-orders' },
    { label: 'My Profile', route: '/profile' },
    { label: 'Saved Addresses', route: '/addresses' },
    { label: 'B2B Wholesale', route: '/b2b' },
  ],
};

export default function Footer() {
  const navigate = useNavigate();

  const linkStyle = {
    background: 'none', border: 'none', padding: 0, cursor: 'pointer',
    fontSize: '0.8125rem', color: '#9ca3af', textAlign: 'left',
    transition: 'color 0.15s',
  };

  const headingStyle = {
    fontWeight: 700, fontSize: '0.875rem', color: 'white',
    marginBottom: '0.75rem', textTransform: 'uppercase',
    letterSpacing: '0.05em',
  };

  return (
    <>
      <style>{`
        /* Reset default ul/li spacing in footer */
        .km-footer-section ul {
          margin: 0;
          padding: 0;
        }
        .km-footer-section li {
          margin: 0;
          padding: 0;
        }

        .km-footer-grid {
          display: grid;
          grid-template-columns: 1.6fr 1fr 1fr 1fr 1fr;
          gap: 2rem;
        }

        @media (max-width: 1024px) {
          .km-footer-grid {
            grid-template-columns: 1.4fr 1fr 1fr 1fr !important;
          }
        }

        @media (max-width: 768px) {
          .km-footer {
            display: none !important;
          }
        }

      `}</style>
      <footer style={{ background: '#1f2937', color: '#d1d5db', padding: '3rem 0 0' }} className="km-footer">
        <div className="container">

          {/* Grid */}
          <div className="km-footer-grid" style={{ paddingBottom: '2rem', borderBottom: '1px solid #374151' }}>

            {/* Brand */}
            <div className="km-footer-brand" style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '0.75rem' }}>
                <img src="/favicon.svg" alt="" width={26} height={26} style={{ display: 'block', borderRadius: 6 }} />
                <span style={{ fontWeight: 800, fontSize: '1.2rem', color: 'white' }}>
                  ePayhub <span style={{ color: '#4ade80' }}>Store</span>
                </span>
              </div>
              <p className="brand-desc" style={{ fontSize: '0.78rem', color: '#9ca3af', lineHeight: 1.6, marginBottom: '0.75rem', maxWidth: 220 }}>
                Fresh groceries delivered fast in Hyderabad. B2C retail and B2B wholesale.
              </p>
              <div className="contact-info" style={{ display: 'flex', flexDirection: 'column', gap: '4px', fontSize: '0.75rem', color: '#9ca3af' }}>
                <span>📍 Hyderabad, Telangana</span>
                <span>📞 +91 98765 43210</span>
                <span>✉️ kilomart685@gmail.com</span>
              </div>
            </div>

            {/* B2C Categories */}
            <div className="km-footer-section">
              <h6 style={headingStyle}>Shop B2C</h6>
              <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '7px' }}>
                {b2cCategories.map(cat => (
                  <li key={cat.id}>
                    <button
                      onClick={() => navigate(`/category/${encodeURIComponent(cat.name)}/${cat.id}`)}
                      style={linkStyle}
                      onMouseEnter={e => e.currentTarget.style.color = '#4ade80'}
                      onMouseLeave={e => e.currentTarget.style.color = '#9ca3af'}
                    >
                      {cat.name}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* B2B Categories */}
            <div className="km-footer-section">
              <h6 style={headingStyle}>Wholesale B2B</h6>
              <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '7px' }}>
                {b2bCategories.map(cat => (
                  <li key={cat.id}>
                    <button
                      onClick={() => navigate(`/b2b/products/${encodeURIComponent(cat.name)}/${cat.id}`)}
                      style={linkStyle}
                      onMouseEnter={e => e.currentTarget.style.color = '#4ade80'}
                      onMouseLeave={e => e.currentTarget.style.color = '#9ca3af'}
                    >
                      {cat.name}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Link columns */}
            {Object.entries(footerLinks).map(([title, links]) => (
              <div key={title} className="km-footer-section">
                <h6 style={headingStyle}>{title}</h6>
                <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '7px' }}>
                  {links.map((l, i) => (
                    <li key={i}>
                      {l.route ? (
                        <button onClick={() => navigate(l.route)}
                          style={linkStyle}
                          onMouseEnter={e => e.currentTarget.style.color = '#4ade80'}
                          onMouseLeave={e => e.currentTarget.style.color = '#9ca3af'}>
                          {l.label}
                        </button>
                      ) : l.href ? (
                        <a href={l.href}
                          style={{ ...linkStyle, display: 'inline-block', textDecoration: 'none' }}
                          onMouseEnter={e => e.currentTarget.style.color = '#4ade80'}
                          onMouseLeave={e => e.currentTarget.style.color = '#9ca3af'}>
                          {l.label}
                        </a>
                      ) : (
                        <span style={{ fontSize: '0.8125rem', color: '#9ca3af' }}>{l.label}</span>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}

          </div>

          {/* Bottom bar */}
          <div style={{ padding: '1rem 0', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: '0.75rem' }} className="km-footer-bottom">
            <span style={{ fontSize: '0.78rem', color: '#6b7280' }}>
              © {new Date().getFullYear()} ePayhub Store. All rights reserved.
            </span>
            <div style={{ display: 'flex', gap: '16px' }} className="km-footer-links">
              {['Privacy Policy', 'Terms of Service', 'Accessibility'].map(l => (
                <a key={l} href="#!" style={{ fontSize: '0.78rem', color: '#6b7280', textDecoration: 'none', transition: 'color 0.15s' }}
                  onMouseEnter={e => e.target.style.color = '#4ade80'}
                  onMouseLeave={e => e.target.style.color = '#6b7280'}>
                  {l}
                </a>
              ))}
            </div>
          </div>

        </div>
      </footer>
    </>
  );
}
